<template>
 <side-base :fulled="true" class="yunxiao x3 locate-address">
    <div class="map-wrapper">
      <div id="container"></div>
      <div class="amap-control amap-geolocation" @click="handlerGetCurrentPosition">
        <img src="https://a.amap.com/jsapi/static/image/plugin/waite.png" v-show="locating">
      </div>
      <div class="zoom-operate" v-if="map">
        <van-icon name="plus" @click="map.zoomIn()"/>
        <van-icon name="minus" @click="map.zoomOut()"/>
      </div>
    </div>
    <div class="search-area">
      <div class="locate-address" v-if="checkedPoi" >
        <van-icon name="location"   />
        {{checkedPoi.name}}
        <p class="sub-title">
          <span>{{checkedPoi.pname}}{{checkedPoi.cityname}}{{checkedPoi.adname}}</span>
          <span>{{checkedPoi.address!==checkedPoi.adname ? checkedPoi.address : ''}}</span>
        </p>
      </div>
      <div class="search-input-area">
        <van-icon name="search" />
        <van-field
          v-model="searchText"
          placeholder="输入机构校区名称或地点搜索"
          clearable
        />
      </div>
      <div class="search-area-result">
        <van-loading type="spinner" size="16px" v-if="searching">
          加载中...
        </van-loading>
        <div class="null-search-result" v-else-if="searchText && !searchResult.length && searchComplete">
          <p>抱歉,没有找到相关的地址</p>
          *如未在地图平台上报过机构校区的地点请先去添加，更有利于家长学员查找路线哦
        </div>
        <div class="result-list" v-else-if="searchResult.length" ref="resultList">
          <div 
            class="result-item" 
            v-for="item of searchResult" 
            :key="item.id"
            @click="doPoiChecked(item)">
            {{item.name}}
            <span class="address">
              <span>{{item.pname}}{{item.cityname}}{{item.adname}}</span>
              <span>{{item.address!==item.adname ? item.address : ''}}</span>
            </span>
            <van-checkbox 
              icon-size="16px" 
              :value="checkedPoi === item"/>
          </div>
        </div>
      </div>
      <page-footer-btn multipleBtns>
        <van-button square round block @click="close" >
          返回
        </van-button>
        <van-button square round block type="primary" @click="confirm(confirmAddress())">
          确定
        </van-button>
      </page-footer-btn>      
    </div>

  </side-base>
</template>

<script>
/**
 * 地图定位获取省市区及详细地址，坐标

 * 返回数据 Object {
    locationCountyCode, // 区code,
    locationCountyName, // 区名称 
    locationCityCode, // 市code ,
    locationCityName,  // 市名 
    locationProvinceCode, // 省code
    locationProvinceName, // 省名称
    locationAddress, // 详细地址
    locationLongitude, // 坐标经度
    locationLatitude, //  坐标纬度
  }

  // 要回显的数据信息
  options Object{
    locationCountyCode, // 区code,
    locationCountyName, // 区名称 
    locationCityCode, // 市code ,
    locationCityName,  // 市名 
    locationProvinceCode, // 省code
    locationProvinceName, // 省名称
    locationAddress, // 详细地址
    locationLongitude, // 坐标经度，必须要有坐标信息，才会回显
    locationLatitude, //  坐标纬度，必须要有坐标信息，才会回显
  }
*/
import AMapLoader from '@amap/amap-jsapi-loader';
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";
import area from "@mlib/js/area.js";
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

let { province_list } = area;
let provinceNameList = {}

// 高德poi返回的省code与我们使用的完全不一致
// 将省名称作为属性名，省code作为值，创建一个对象
// 方便快速获取我们库对应的省code，
for (let prop of Object.keys(province_list)) {
  provinceNameList[province_list[prop]] = prop
}

export default {
  name: 'x3-side-locateAddress',  
  components: {
    pageFooterBtn,
  }, 
  mixins: [sideMixin],
  data () {
    return {
      pageTitle: '校区位置设置',
      map: '', // 保存地图对象
      locating: false, // 是否处理加载中
      mapCenterPosition: [], // 地图中心点
      mapCurrentPosition: [], // 当前定位坐标
      searchText: '', 
      searchResult: [], // 搜索结果
      searching: false, 
      searchComplete: false,
      checkedPoi: '',
    }
  },
  async mounted () {
    let opts = this.$vxRoute.meta.options || {};

    this.showLoading();
    // 添加下面一行，处理第二次进入，visible为false,
    // 导致container不存在，初始化地址报错的问题
    await app.tool.timeout(0);
    await this.initMap();
    this.mapDragendEventListner();
    this.$toast.clear();


    // 如果传入坐标，直接回显位置
    if (opts.locationLongitude && opts.locationLatitude) {
      let location = new this.AMap.LngLat(opts.locationLongitude, opts.locationLatitude);
      
      this.checkedPoi = {
        pname: opts.locationProvinceName, 
        cityname: opts.locationCityName, 
        address: opts.locationAddress,
        adname: opts.locationCountyName, 
        adcode: opts.locationCountyCode,
        location,
      }
      
      this.mapCenterPosition = location;
      // 第一次获取当前位图成功，需要初始化提示信息弹窗
      this.initTipsInfoWindow(location);

    } else {
      // 标记自动选中第一个
      this.doChooseFirstPoi = true;
      // 获取当前位置
      this.getCurrentPosition()
        .then(({position}) => {
          if (position) {
            // 第一次获取当前位图成功，需要初始化提示信息弹窗
            this.initTipsInfoWindow(position);
          }
        })
        .catch(() => {  
          // 如果定位发生错误
          // 需要尝试展示提示信息弹窗,设置中中心点图标和和搜索信息
          let center = this.map && this.map.getCenter();
          if (center) {
            this.initTipsInfoWindow(center);
            this.mapCenterPosition = center;
          }
        });
    }



  },
  watch: {
    // 监听定位点变化，并记录，方便下次快速定位的上次点
    mapCurrentPosition (v) {
      app.ls.set('AMap.Geolocation_center', v);
    },
    /**
     * 监听地图中心点变化
     * 中心点变化需要更新中心点marker坐标
     * 需要重新搜索周边poi点位
     */
    mapCenterPosition (v) {
      this.updataCenterMarkerPositon(v);
      if (!this.searchText) {
        this.nearbySearch(v)
      } else {
        // 如果存在searchText值，清空searchText同样会引起nearbySearch搜索
        this.searchText = '';
      }
    },
    /**
     * 监听搜索字段修改，进行poi点搜索
     * 已经添加节流
     */
    searchText (v) {
      this.searchComplete = false
      if (v) {
        if (!this.debounceDoSeacher) this.debounceDoSeacher = app.tool.debounce(this.doSeacher, 500);
        this.debounceDoSeacher();
      } else if (this.mapCenterPosition) {
        // 要清除文字搜索的防抖
        this.debounceDoSeacher && this.debounceDoSeacher.clear();
        this.nearbySearch(this.mapCenterPosition);
      }
    }
  },
  methods: {
    /**
     * 初始化地图组件
     * 初始化地图
     */
    initMap () {
      // 这里，改成用兵哥私人的账号key和密钥了
      // 是针对高德地图对公服务API调用要收费问题的临时解决方案
      window._AMapSecurityConfig = {
          securityJsCode:'e83788224b29f0c0aac4104e64185bec',
      }
      return AMapLoader.load({
        "key": "ccf7723642b3960044a6a2aa5fe62e88",              
        "plugins": ["AMap.Geolocation", "AMap.PlaceSearch"],
        "version": "2.0",   
      }).then((AMap)=>{

        this.AMap = AMap;
        let opts = this.$vxRoute.meta.options || {};
        let mapOpts = {zoom: 18};
        // 如果存在上次记录的中心点，中心点设为上次点
        let center = app.ls.get('AMap.Geolocation_center');
        // 如果存在回显坐标，地图中心点直接设置为回显坐标
        if (opts.locationLongitude && opts.locationLatitude) {
          center = [opts.locationLongitude, opts.locationLatitude];
        }
        if (center) {
          mapOpts.center = center;
        }
        this.map = new AMap.Map('container', mapOpts);  

      }).catch(e => {
          console.log(e);
      })
    },
    /**
     * 将点击定位按钮定位的事件，用函数包一下
     * 避免定位失败时在控制台提示错误
     */
    handlerGetCurrentPosition () {
      this.getCurrentPosition();
    },
    /**
     * 定位入口，考虑后期可以会使用微信定位
     * 所有这里多做了一层
     * 同时，在这里统一处理了定位出错的提示
     */
    getCurrentPosition () {
      this.locating = true;
      let locationPromise = app.base.env!=='wx' ? this.aMapGetCurrentPosition() : this.wxGetCurrentPosition();
      return locationPromise.catch((opt) => {
        (opt.msg || opts.errMsg) && this.$toast(opt.msg || opts.errMsg);      
      })
    },
    /**
     * 微信获取位置
     */
    wxGetCurrentPosition () {
      let $this = this;
      let promise = new Promise((resolve, reject) => {
        app.sdk.wxReadyPromise
          .then(()=>{
            wx.getLocation({
              success (res) {
                $this.AMap.convertFrom([res.longitude, res.latitude], 'gps', function (status, result) {
                  if (result.info === 'ok') {
                    // resolve({position: [result.locations[0].lng,result.locations[0].lat]});
                    // $this.wxGetLocation({position: [result.locations[0].lng,result.locations[0].lat]});
                    resolve({position: result.locations[0]});
                    $this.wxGetLocation({position: result.locations[0]});
                  } else {
                    reject([result, status])
                  }
                })
                $this.locating = false;
              },
              fail (res) {
                reject({msg: '定位拒绝或失败，请允许或稍后重试...'});       
                $this.locating = false;
              },
            })
          })
          wx.error((res) => {
            reject({msg: '权限错误，请稍后重试...'});          
            this.locating = false;
          });
      })

      return promise; 
    },
    /**
     * 高德地图定位
     */
    aMapGetCurrentPosition () {
      // 还不存在map实例，直接返回
      if (!this.map) {
        this.locating = false;
        return false;
      }
      // 未初始化定位插件，初始化
      if (!this.geolocation) {
        this.geolocation = new AMap.Geolocation({
          timeout: 10000,
          position:'LB',
          buttonOffset: new AMap.Pixel(10, 20), 
          zoomToAccuracy: true,
          needAddress: true, // 设置返回地址信息
          showButton: false,
        });
      }
      // 添加定位组件的控件(marker)到地址
      this.map.addControl(this.geolocation);

      // 以promise方式返回定位坐标
      return new Promise((resolve, reject) => {
        this.geolocation.getCurrentPosition((status,result) => {
          if(status=='complete'){
            this.getLocationSuccess(result)

            // 返回定位结果
            resolve(result)
          }
          
          if (status === 'error' && result.status === 1) {
            reject({msg: '定位拒绝或失败，请允许或稍后重试...'})
          }
          this.locating = false;
          
        });
      })

    },

    /**
     * 初始化搜索插件
     */
    initPlaceSearch () {
      this.PlaceSearch = new AMap.PlaceSearch({
        pageSize: 20, // 单页显示结果条数
        pageIndex: 1, // 页码
        extensions: 'all',
        type: '地名地址信息|生活服务|科教文化服务|体育休闲服务|公司企业|商务住宅|政府机构及社会团体'
      });
      // 搜索完成更新结果 
      this.PlaceSearch.on("complete", (result)=> {
        this.searchResult = result.poiList.pois;
        // 标记不自动选中第一个，就选中第一个
        // 只有第一次搜索且没有数据回显时，自动选择
        if (this.doChooseFirstPoi) { 
          this.checkedPoi = this.searchResult[0];
          this.doChooseFirstPoi = false;
        }
        this.searching = false;
        this.searchComplete = true;
        this.$nextTick(()=>{  
          this.$refs.resultList && (this.$refs.resultList.scrollTop = 0);
        })
      }); 
      // 搜索失败更新结果        
      this.PlaceSearch.on("error", (result)=> {
        this.searchResult = [];
        this.searching = false;
        this.searchComplete = true;
      }); 
    },
    /**
     * 关键字搜索(搜索框搜索)
     */
    doSeacher () {
      if (!this.map) return false;
      if (!this.searchText) return false;
      if (!this.PlaceSearch) {
        this.initPlaceSearch();
      }
      this.searching = true;
      this.PlaceSearch.search(this.searchText);
    },
    /**
     * 附近搜索
     * 地图中心点更改搜索
     */
    nearbySearch (position) {
      if (!this.map) return false;
      // 拖动的搜索和搜索框搜索不并行
      // 所以这里需要去掉搜索框内容，以免误导
      this.searchText = '';
      if (!this.PlaceSearch) {
        this.initPlaceSearch();
      }
      this.searching = true;
      this.PlaceSearch.searchNearBy('', position, 3000);
    },
    // 更新地图中心点marker位置
    // 第一次更新时会顺带先创建下marker
    updataCenterMarkerPositon (position) {
      if (!this.map) return false;
      if (!this.marker) {
        this.marker = new AMap.Marker({
          animation: 'AMAP_ANIMATION_BOUNCE',
          icon: new AMap.Icon({
            size: new AMap.Size(32, 32),
            image: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/x3/location-on.png',
            imageSize: new AMap.Size(32, 32),
          }),
          position,
          offset: new AMap.Pixel(-16, -30),
          zIndex: 100,
        });
        this.marker.setMap(this.map);
      } else {
        this.marker.setPosition(position)
      }
    },
    /**
     * 创建“拖拽地图选择机构位置”提示弹窗
     * 在地图拖动后关闭
     */
    initTipsInfoWindow (position){
      if (!this.infoWindow) {
        this.infoWindow = new AMap.InfoWindow({
          content: '拖拽地图选择位置',
          offset: new AMap.Pixel(0, -30),
        });
      }
      this.infoWindow.open(this.map, position);
    },
    /**
     * 监听地图拖动结束
     * 拖动结束更新地图中心点
     * 同时关闭“拖拽地图选择机构位置”提示弹窗
     */
    mapDragendEventListner () {
      this.map && this.map.on('dragend', () => {
        this.mapCenterPosition = this.map.getCenter();
        if (this.infoWindow) {
          this.infoWindow.close();
          this.infoWindow = null;
        }
      })
    },

    // 格式化数据
    confirmAddress () {
      let {
          name,
          pname, 
          cityname, 
          address,
          adname, 
          adcode,
          location
        } = this.checkedPoi
      let provinceName = pname
      let detailAddress =  address
      let cityName = cityname;
      let countyName = adname


      // 搜索到的poi点会出现区名称和详情地址名称相同
      // 相同时详情地址使用poi名称
      if (countyName === detailAddress) detailAddress = name;

      let addressObj = {
        locationCountyCode: adcode,
        locationCountyName: adname,
        // 市code就等于poi点的区码后两位替换为0;
        locationCityCode: adcode.replace(/\d{2}$/, '00'),
        locationCityName: cityName, 
        locationProvinceCode: provinceNameList[provinceName],
        locationProvinceName: provinceName,
        locationAddress: detailAddress,
        locationLongitude: location.lng,
        locationLatitude: location.lat,
      }

      return addressObj;
    },
    /**
     * 微信获取位置成功后的相关操作
     */
    wxGetLocation ({position}) {
      this.map.setCenter(position);
      this.setWxLocationMarker(position);
      this.getLocationSuccess({position});
    },
    /**
     * 使用微信js-sdk定位，需要单独设置定位点marker图标
     */
    setWxLocationMarker (position) {
      if (!this.map) return false;
      if (!this.wxLocationmarker) {
        this.wxLocationmarker = new AMap.Marker({
          animation: 'AMAP_ANIMATION_BOUNCE',
          icon: new AMap.Icon({
            size: new AMap.Size(20, 20),
            image: 'https://a.amap.com/jsapi/static/image/plugin/point.png',
            imageSize: new AMap.Size(20, 20),
          }),
          position,
          offset: new AMap.Pixel(-10, -10),
          zIndex: 99,
        });
        this.wxLocationmarker.setMap(this.map);
        this.wxLocationmarker.dom && this.wxLocationmarker.dom.classList.add('amap-geolocation-marker');
      } else {
        this.wxLocationmarker.setPosition(position)
      }
      
    },
    // 定位成功相关统一逻辑
    getLocationSuccess ({position}) {
      this.mapCurrentPosition = position;            
      this.mapCenterPosition = position;
    },
    /**
     * 选中POI，同时定位到选中位置
     */
    doPoiChecked (item) {
      if (this.checkedPoi !== item) {
        this.checkedPoi = item;
        if (item.location) {
          this.map.setCenter(item.location);
          this.updataCenterMarkerPositon(item.location);
          this.infoWindow && this.initTipsInfoWindow(item.location);
        }
      }
    }
  }
}
</script>

<style lang="scss">
.yunxiao.x3.locate-address{
  display: flex;
  flex-flow: column;
  overflow: hidden;
  .map-wrapper{
    position: relative;
    flex: 1;
  }
  #container{
    height: 100%;
    .amap-info{
      .amap-info-sharp{
        bottom: 2px;
      }
      .amap-info-content{
        margin-left: 8px;
        padding: 10px;
        color: var(--g8);
        border-radius: 24px;
      }
      .amap-info-close{
        display: none;
      }
    }
  }
  .search-area{
    display: flex;
    flex-direction: column;
    padding: 16px 16px 0 16px;
    height: 56%;
    background: var(--white);
  }
  .locate-address{
    position: relative;
    margin-bottom: 8px;
    padding: 0 0 0 18px;
    min-height: 38px;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    font-weight: bold;
    color: var(--c1);
    .van-icon-location{
      position: absolute;
      top: 2px;
      left: 0px;
      font-size: var(--fs-lg);
    }
    .sub-title{
      margin: 0;
      font-weight: normal;
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
    }
  }
  .search-area-result{
    flex: 1;
    overflow: hidden;
    .van-loading {
      margin: 16px 0 0;
      text-align: center;
    }
    .null-search-result{
      padding: 32px 26px 0 26px;
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      color: var(--g5);
      p{
        margin: 0 0 8px 0;
        color: var(--g6);
        font-size: var(--fs-lg);
      }
    }
    .result-list{
      height: 100%;
      overflow-y: auto;
      .result-item{
        position: relative;
        margin: 4px;
        padding:0 32px 16px 0;        
        line-height: var(--lh-lg);

        .address{
          display: block;
          font-size: var(--fs-sm);
          line-height: 16px;
          color: var(--g7);
        }
        .van-checkbox{
          position: absolute;
          margin: auto;
          right: 8px;
          bottom: 0;
          top: 0;
        }
      }
    }
  }
  .footer.multiple-btns{
    padding:3px 0;
  }
  .search-input-area{
    position: relative;
    display: flex;
    margin: 0 8px 8px;
    align-items: center;
    padding:0 14px 0 36px;
    height: 36px;
    background: var(--g1);
    border-radius: 18px;
    .van-icon-search{
      position: absolute;
      height: 14px;
      margin: auto;
      top:0;
      left: 18px;
      bottom: 0;

      font-size: var(--fs-md);
      color: var(--g5);
    }
    .van-field{
      padding: 0;
      font-size: var(--fs-md);
      background: transparent;
    }
  }
  .amap-logo,
  .amap-copyright{
    display: none !important;
  }
  .amap-geolocation{
    right: unset;
    left: 10px;
    bottom: 12px;
    border-radius:0;
  }
  .zoom-operate{
    position: absolute;
    right: 10px;
    bottom: 12px;
    display: flex;
    flex-direction: column;
    width: 30px;
    height: 64px;

    background: var(--white);
    .van-icon{
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }
  }
}
</style>